export const TEXT_BUTTON_ORDERED_LIST = 'text-button-ordered-list';
